"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObservabilityPipelineGenerateMetricsProcessor = void 0;
/**
 * The `generate_datadog_metrics` processor creates custom metrics from logs and sends them to Datadog.
 * Metrics can be counters, gauges, or distributions and optionally grouped by log fields.
 */
class ObservabilityPipelineGenerateMetricsProcessor {
    constructor() { }
    /**
     * @ignore
     */
    static getAttributeTypeMap() {
        return ObservabilityPipelineGenerateMetricsProcessor.attributeTypeMap;
    }
}
exports.ObservabilityPipelineGenerateMetricsProcessor = ObservabilityPipelineGenerateMetricsProcessor;
/**
 * @ignore
 */
ObservabilityPipelineGenerateMetricsProcessor.attributeTypeMap = {
    id: {
        baseName: "id",
        type: "string",
        required: true,
    },
    include: {
        baseName: "include",
        type: "string",
        required: true,
    },
    inputs: {
        baseName: "inputs",
        type: "Array<string>",
        required: true,
    },
    metrics: {
        baseName: "metrics",
        type: "Array<ObservabilityPipelineGeneratedMetric>",
        required: true,
    },
    type: {
        baseName: "type",
        type: "ObservabilityPipelineGenerateMetricsProcessorType",
        required: true,
    },
    additionalProperties: {
        baseName: "additionalProperties",
        type: "any",
    },
};
//# sourceMappingURL=ObservabilityPipelineGenerateMetricsProcessor.js.map